import { styled } from 'styled-components';

import CommonButtonIcon from '../../Common/ButtonIcon';

export const ButtonIcon = styled(CommonButtonIcon)`
  padding: var(--spacing-tiny);
`;
